<section class="page"><h1>Administración del sistema</h1>
<nav class="admin-sections" aria-label="Administración">@for(section of sections;track section.path){<a [routerLink]="section.path" routerLinkActive="active" ariaCurrentWhenActive="page">{{section.label}}</a>}</nav>
@if(!authorities()) {
@if(api.loading()){<p role="status">Cargando administración…</p>}
@if(api.error()){<p role="alert" class="admin-error">{{api.error()}}</p><button type="button" (click)="api.load()" [disabled]="api.loading() || api.busy()">Actualizar información</button>}
@if(api.notice()){<p role="status">{{api.notice()}}</p>}
@if(api.data()){
<label>Instrumento <select [ngModel]="api.instrumentId()" (ngModelChange)="api.instrumentId.set($event)" [disabled]="api.busy()">@for(instrument of api.data()?.instruments ?? [];track instrument.id){<option [value]="instrument.id">{{instrument.name}}</option>}</select></label>
@if(!api.instrumentId()){<p role="status">No tiene instrumentos habilitados para administración.</p>}
}
}
<router-outlet />
</section>
